import { render, staticRenderFns } from "./VideoHandle.vue?vue&type=template&id=2679877a&scoped=true&"
import script from "./VideoHandle.vue?vue&type=script&lang=js&"
export * from "./VideoHandle.vue?vue&type=script&lang=js&"
import style0 from "./VideoHandle.vue?vue&type=style&index=0&id=2679877a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679877a",
  null
  
)

export default component.exports